import SockJS from "sockjs-client"
import { Client } from "@stomp/stompjs"

let stompClient = null

export function connectSocket(onMessage) {
  const wsListen = import.meta.env.VITE_VIDEO_WS_LISTEN;

  const socket = new SockJS(wsListen)

  stompClient = new Client({
    webSocketFactory: () => socket,
    onConnect: () => {
      stompClient.subscribe("/topic/events", (msg) => {
        const data = JSON.parse(msg.body)
        onMessage(data)
      })
    }
  })

  stompClient.activate()
}
